import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessIcon from '../Icons/SuccessIcon';

interface Props {
  toggleOut(): void;
  toggle(): void;
}

const SuccessModalIndividual: React.FC<Props> = ({ toggle, toggleOut }) => {
  const { t } = useTranslation(['includeTeam']);

  return (
    <div className="success-wrapper" data-testid="include-one-success">
      <div className="icon-wrapper">
        <SuccessIcon />
      </div>
      <span className="title-success">{t('success_include')}</span>
      <span className="subtitle">{t('check_list')}</span>
      <div className="btn-wrapper-confirmation">
        <button type="button" className="ok-button" onClick={toggleOut}>
          {t('include_another')}
        </button>
      </div>
    </div>
  );
};

export default SuccessModalIndividual;
